import Vue from 'vue';
// helper
import { TrackingService } from "@/helper/TrackingHelper.js";
import Locale from '@/helper/locale/locale.js';
// modal
import ModalFactory from "@/components/Modal/ModalFactory.js";
// service
import { CategoryConfigBuilder } from '@/core/Campaign/model/CategoryConfigModel.js';
import RewardService from '@/core/Custom/service/RewardService';
export default {
    data: function () {
        return {
            isLoaded: false,
            headerText: '',
            pageName: 'home',

            category: {},
            mainCategory: {},
            categoryList: [],
            isAmbassadorCategory: false,

            trackingService: new TrackingService(this),
            trackingScreenName: 'subcategory_list',
            localeCode: Locale.getLocaleCode(),
        }
    },
    computed: {
        ambassadorCatId: function () {
            return this.$store.getters.getAmbassadorCatId;
        }
    },
    created: function () {
        this.initialModal();
        this.trackingService.screenName(this.trackingScreenName);

    },
    mounted: function () {
        this.showLoading();
    },
    methods: {
        initialMenuCategory: function (cateId, subCatId) {
            var categoryName;
            if (this.tier == 'm') {
                categoryName = this.isAmbassador
                    ? Vue.bzbsConfig.categoryConfig.mass_am
                    : Vue.bzbsConfig.categoryConfig.mass;
            } else {
                categoryName = this.isAmbassador
                    ? Vue.bzbsConfig.categoryConfig.prestige_am
                    : Vue.bzbsConfig.categoryConfig.prestige;
            }

            var menuCategoryConfig = new CategoryConfigBuilder()
                .setConfig(categoryName)
                .create();

            var token = this.getToken();
            return new Promise((resolve, reject) => {
                RewardService.apiGetCategory(token, menuCategoryConfig.getParams())
                    .then(res => {
                        var filteredCate = res.filter(category => {
                            return (category.id == cateId);
                        });

                        if (filteredCate.length > 0) {
                            this.headerText = this.localeCode == 1033 ? filteredCate[0].name_en : filteredCate[0].name_th;
                            this.mainCategory = {...filteredCate[0]};

                            if (filteredCate[0].subcats
                                && filteredCate[0].subcats.length > 0)
                                this.categoryList = [...filteredCate[0].subcats];
                        }

                        this.isAmbassadorCategory = (this.mainCategory.id == this.ambassadorCatId);

                        if (subCatId) {
                            const result = this.categoryList.filter(val => val.id == subCatId);
                            if (result.length > 0) {
                                resolve(result[0]);
                            } else {
                                resolve(null);
                            }
                        } else {
                            resolve(null);
                        }
                    }).catch(err => {
                        reject(err);
                    });
            });
        },
        initialModal: function () {
            var modalFactory = new ModalFactory();
            this.modalController = modalFactory.getModalController();
            this.alertModal = modalFactory.getAlertModal();
            this.confirmModal = modalFactory.getConfirmModal();
            this.loadingModal = modalFactory.getLoadingModal();
            this.noInternetModal = modalFactory.getNoInternetModal();
        },
        showLoading: function () {
            if (this.isLoading) return true;

            this.isLoading = true;
            this.modalController.loadingModal.show();

            return false;
        },
        hideLoading: function () {
            this.isLoading = false;
            this.modalController.loadingModal.hide();
        }
    }
}
